import { Injectable } from "@angular/core";
import { UtenteVO } from "../vo/utenteVO";
import { SettoreVO } from "../vo/settoreVO";
import { AutenticazioneService } from "../services/autenticazione.service";
import { TipoVisibilitaEnum } from "../enum/tipo-visibilita-enum";
import { VisibilitaFascicoloVO } from "../vo/visibilita-fascicoloVO";

@Injectable({
  providedIn: "root",
})
export class ProfiliHelper {
  utente: UtenteVO;
  constructor(private autenticazioneService: AutenticazioneService) {
    this.utente = this.autenticazioneService.getUtente();
  }

  public isUtenteMultiSettore() {
    return (
      this.utente.profili.filter((value) => value.codice === "FASC").length > 0
    );
  }

  public getSettoriEstensore() {
    let settoriEstensore: SettoreVO[];
    settoriEstensore = this.utente.profili
        .filter((value) => value.codice === "FASC")
        .map((value) => value.settori[0]);

    let settoriResponsabile: SettoreVO[];
    settoriResponsabile = this.utente.profili
      .filter((value) => value.codice === "RESP")
      .map((value) => value.settori[0]);

    const settoriListaUnica: SettoreVO[] = new Array<SettoreVO>();

    settoriEstensore.forEach((element) => {
      settoriListaUnica.push(element);
    });
    settoriResponsabile.forEach((element) => {
      settoriListaUnica.push(element);
    });

    let settori: SettoreVO[] = new Array<SettoreVO>();

    settori = settoriListaUnica.filter(
      (value, index, array) =>
        !array.filter((v, i) => value.codice === v.codice && i < index).length
    );

    return settori;
  }

  public getSettoriRedattore() {
    return this.utente.profili
      .filter((value) => value.codice === "REDAT")
      .map((value) => value.settori[0]);
  }

  public getSettoriVerificatore() {
    return this.utente.profili
      .filter((value) => value.codice === "VERIF")
      .map((value) => value.settori[0]);
  }

  public getSettoriUtenteModuloAtti(): SettoreVO[] {
    const mapSettori: Map<string, SettoreVO> = new Map();
    this.utente.profili
      .filter((value) => value.codice === "REDAT" || value.codice == "VERIF")
      .forEach((value) =>
        mapSettori.set(value.settori[0].codice, value.settori[0])
      );
    return Array.from(mapSettori.values());
  }

  public getSettoriUtenteModuloNote(): SettoreVO[] {
    const mapSettori: Map<string, SettoreVO> = new Map();
    this.utente.profili
      .filter((value) => value.codice === "ESTENLIQ" || value.codice == "VERIF")
      .forEach((value) =>
        mapSettori.set(value.settori[0].codice, value.settori[0])
      );
    return Array.from(mapSettori.values());
  }

  public getSettoriEstensoreLiquidazione(): SettoreVO[] {
    let settoriEstensoreLiq: SettoreVO[];
    settoriEstensoreLiq = this.utente.profili
      .filter((value) => value.codice === "ESTENLIQ")
      .map((value) => value.settori[0]);

    let settoriResponsabile: SettoreVO[];
    settoriResponsabile = this.utente.profili
      .filter((value) => value.codice === "RESP")
      .map((value) => value.settori[0]);

    const settoriListaUnica: SettoreVO[] = new Array<SettoreVO>();

    settoriEstensoreLiq.forEach((element) => {
      settoriListaUnica.push(element);
    });
    settoriResponsabile.forEach((element) => {
      settoriListaUnica.push(element);
    });

    let settori: SettoreVO[] = new Array<SettoreVO>();

    settori = settoriListaUnica.filter(
      (value, index, array) =>
        !array.filter((v, i) => value.codice === v.codice && i < index).length
    );

    return settori;
  }

  public getSettoriEstensoreConsultatore() {
    let settoriEstensore: SettoreVO[];
    settoriEstensore = this.utente.profili
      .filter((value) => value.codice === "FASC")
      .map((value) => value.settori[0]);

    let settoriConsultatore: SettoreVO[];
    settoriConsultatore = this.utente.profili
      .filter((value) => value.codice === "LETT")
      .map((value) => value.settori[0]);

    let settoriResponsabile: SettoreVO[];
    settoriResponsabile = this.utente.profili
      .filter((value) => value.codice === "RESP")
      .map((value) => value.settori[0]);

    const settoriListaUnica: SettoreVO[] = new Array<SettoreVO>();

    settoriEstensore.forEach((element) => {
      settoriListaUnica.push(element);
    });
    settoriResponsabile.forEach((element) => {
      settoriListaUnica.push(element);
    });
    settoriConsultatore.forEach((element) => {
      settoriListaUnica.push(element);
    });
    let settori: SettoreVO[] = new Array<SettoreVO>();

    settori = settoriListaUnica.filter(
      (value, index, array) =>
        !array.filter((v, i) => value.codice === v.codice && i < index).length
    );

    return settori;
  }

  public isResponsabilePerCmu(cmu: string): boolean {
    let stato: boolean = false;
    this.utente.profili
      .filter((value) => value.codice === "RESP")
      .forEach((profiloRes) => {
        profiloRes.settori.forEach((settore) => {
          if (settore.codice === cmu) {
            stato = true;
            return stato;
          }
        });
      });
    return stato;
  }

  public haRuoliSettoreAppartenenza(cmu: string): boolean {
    let stato: boolean = false;
    this.utente.profili
      .filter((value) => value.codice === "FASC" || value.codice === "LETT")
      .forEach((profiloRes) => {
        profiloRes.settori.forEach((settore) => {
          if (settore.codice === cmu) {
            stato = true;
            return;
          }
        });
      });
    return stato;
  }

  public isResponsabileGestioneDocumentale(): boolean {
    let stato: boolean = false;
    this.utente.profili
      .filter((value) => value.codice === "RGD")
      .forEach((_) => {
        stato = true;
        return;
      });
    return stato;
  }

  public isRGDSenzaVisibilita(
    visibilitaFascicolo: VisibilitaFascicoloVO[]
  ): boolean {
    let readonly: boolean = true;
    const visibilita: VisibilitaFascicoloVO = visibilitaFascicolo
      .filter(
        (res) =>
          res.utente.id == this.utente.id && res.dataFineVisibilita == null
      )
      .pop();
    if (visibilita) {
      switch (visibilita.tipoVisibilita) {
        case TipoVisibilitaEnum.MODIFICA: {
          readonly = false;
          break;
        }
        case TipoVisibilitaEnum.SOLA_LETTURA: {
          readonly = true;
          break;
        }
        case TipoVisibilitaEnum.PROPRIETARIO: {
          readonly = false;
          break;
        }
        default: {
          readonly = true;
          break;
        }
      }
    }
    console.log("[ProfiliHelper][visibilità fascicolo]", visibilita);

    console.log("[ProfiliHelper][isRGDSenzaVisibilita]", readonly);
    return readonly;
  }

  public haVisibilitaInListaVisibilita(
    listaVisibilita: VisibilitaFascicoloVO[]
  ): boolean {
    let haVisibilita: boolean = false;
    const visibilita: VisibilitaFascicoloVO = listaVisibilita
      .filter(
        (res) =>
          res.utente.id === this.utente.id && res.dataFineVisibilita == null
      )
      .pop();
    if (visibilita) {
      haVisibilita = true;
    }
    // console.log(
    //   "[ProfiliHelper][ haVisibilitaInListaVisibilita]listaVisibilita: ",
    //   listaVisibilita
    // );

    // console.log(
    //   "[ProfiliHelper][haVisibilitaInListaVisibilita]haVisibilita: ",
    //   haVisibilita
    // );
    return haVisibilita;
  }

  public getSettoriResponsabile() {
    let settoriResponsabile: SettoreVO[];
    settoriResponsabile = this.utente.profili
        .filter((value) => value.codice === "RESP")
        .map((value) => value.settori[0]);

    let settori: SettoreVO[] = new Array<SettoreVO>();

    settori = settoriResponsabile.filter(
        (value, index, array) =>
            !array.filter((v, i) => value.codice === v.codice && i < index).length
    );
    return settori;
  }

  public haPermessiDiScrittura(
    listaVisibilita: VisibilitaFascicoloVO[]
  ): boolean {
    let visibilitaScrittura: boolean = false;
    const visibilita: VisibilitaFascicoloVO = listaVisibilita
      .filter(
        (res) =>
          res.utente.id == this.utente.id &&
          res.dataFineVisibilita == null &&
          (res.tipoVisibilita === TipoVisibilitaEnum.MODIFICA ||
            res.tipoVisibilita === TipoVisibilitaEnum.PROPRIETARIO)
      )
      .pop();
    if (visibilita) {
      visibilitaScrittura = true;
    }
    return visibilitaScrittura;
  }
}
